<template>
  <div class="loading-spinner-container">
    <div class="loading-spinner" :class="size">
      <div class="spinner-ring"></div>
      <div class="spinner-ring"></div>
      <div class="spinner-ring"></div>
      <div class="spinner-ring"></div>
    </div>
    <p v-if="message" class="loading-message">{{ message }}</p>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: {
    size: {
      type: String,
      default: 'medium',
      validator: value => ['small', 'medium', 'large'].includes(value)
    },
    message: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.loading-spinner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 20px;
  backdrop-filter: blur(8px);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.02);
}

.loading-spinner {
  position: relative;
  display: inline-block;
}

.loading-spinner.small {
  width: 32px;
  height: 32px;
}

.loading-spinner.medium {
  width: 48px;
  height: 48px;
}

.loading-spinner.large {
  width: 64px;
  height: 64px;
}

.spinner-ring {
  position: absolute;
  border: 2px solid transparent;
  border-radius: 50%;
  animation: spin 1.2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}

.loading-spinner.small .spinner-ring {
  width: 28px;
  height: 28px;
}

.loading-spinner.medium .spinner-ring {
  width: 44px;
  height: 44px;
}

.loading-spinner.large .spinner-ring {
  width: 60px;
  height: 60px;
}

/* Modern gradient rings */
.spinner-ring:nth-child(1) {
  border-top: 2px solid #60a5fa;
  border-right: 2px solid rgba(96, 165, 250, 0.3);
  animation-delay: -0.45s;
}

.spinner-ring:nth-child(2) {
  border-top: 2px solid #34d399;
  border-right: 2px solid rgba(52, 211, 153, 0.3);
  animation-delay: -0.3s;
  animation-direction: reverse;
}

.spinner-ring:nth-child(3) {
  border-top: 2px solid #f472b6;
  border-right: 2px solid rgba(244, 114, 182, 0.3);
  animation-delay: -0.15s;
}

.spinner-ring:nth-child(4) {
  border-top: 2px solid #fbbf24;
  border-right: 2px solid rgba(251, 191, 36, 0.3);
  animation-delay: 0s;
  animation-direction: reverse;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading-message {
  margin-top: 16px;
  color: #e2e8f0;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  letter-spacing: 0.025em;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 0.8;
  }
  50% {
    opacity: 1;
  }
}
</style>